module.exports = __webpack_public_path__ + "static/ecosystem-1e09abbf5d1be1077566e5dd69acde57.svg";